import axios from 'axios';

export default axios.create({
  baseURL: `https://marketplace.api.healthcare.gov/api/v1/`,
});
